import { adminApi, apiFetch } from "@/lib/auth-api";
import type { ResolveResponse, VisibilityRule } from "@/lib/visibility-types";

export async function fetchMyVisibilityRules(): Promise<VisibilityRule[]> {
	return adminApi.getMyVisibilityRules();
}

export async function fetchVisibilityRules(role?: string): Promise<VisibilityRule[]> {
	return adminApi.getVisibilityRules(role);
}

export async function upsertVisibilityRule(rule: {
	role: string;
	elementId: string;
	visible: boolean;
}): Promise<void> {
	await adminApi.upsertVisibilityRule(rule);
}

export async function upsertVisibilityRuleForAllRoles(rule: {
	elementId: string;
	visible: boolean;
}): Promise<void> {
	return adminApi.upsertVisibilityRuleForAllRoles(rule);
}

export async function deleteVisibilityRule(ruleId: number): Promise<void> {
	return adminApi.deleteVisibilityRule(ruleId);
}

export async function fetchResolveRole(role: string): Promise<ResolveResponse> {
	const params = new URLSearchParams({ role });
	return apiFetch<ResolveResponse>(`/admin/visibility/resolve?${params}`);
}
